export const iconFontAwesomeArrowsArrowUpLong = (
	<i className="fa-solid fa-arrow-up-long"></i>
);
